import { render, staticRenderFns } from "./AppNav.vue?vue&type=template&id=5cd65205&"
import script from "./AppNav.vue?vue&type=script&lang=js&"
export * from "./AppNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports